<template>
  <v-dialog v-model="dialog" max-width="700px">
    <v-form ref="form" @submit.prevent="() => $emit('salvar', fornecedor)">
      <v-card v-if="fornecedor" :loading="salvando">
        <v-card-title>
          {{ operacao === 'editar' ? 'Editar' : 'Adicionar' }} Fornecedor
        </v-card-title>
        <v-card-text>
          <v-form ref="formDialog" v-model="validForm" @submit.prevent>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="fornecedor.nome"
                    label="Nome"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <CampoDeCpfOuCnpj
                    v-model="fornecedor.documento"
                    label="CPF / CNPJ"
                    :disabled="operacao === 'editar'"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    v-model="fornecedor.uf.id"
                    :items="itens.uf"
                    :rules="[obrigatorio]"
                    label="UF"
                  />
                </v-col>
                <v-col>
                  <v-autocomplete
                    v-model="fornecedor.tipoFornecedor"
                    :items="itens.tiposFornecedores"
                    :rules="[obrigatorio]"
                    label="Tipo Fornecedor"
                  />
                </v-col>
              </v-row>
              <v-switch
                v-if="operacao === 'editar'"
                v-model="fornecedor.conferido"
                label="Conferido"
                dense
              />
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-alert v-if="showMessageError" dense outlined type="error">
                    {{ dataError }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" type="button" text @click="dialog = false">Cancelar</v-btn>
          <v-btn
            class="ml-auto"
            type="submit"
            text
            color="success"
            :disabled="!validForm"
            @click="salvar(fornecedor)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Fornecedor from '../../models/fornecedor'
import FornecedorService from '../../services/fornecedor/fornecedor'
import { obrigatorio } from '../../shareds/regrasForm'
import CampoDeCpfOuCnpj from '../ui/CampoDeCpfOuCnpj.vue'

export default {
  components: { CampoDeCpfOuCnpj },
  props: ['showDialog', 'fornecedorParam', 'operacao', 'itens'],

  data: () => ({
    dialog: false,
    fornecedor: new Fornecedor(),
    obrigatorio: obrigatorio,
    salvando: false,
    showMessageError: false,
    validForm: false,
    newTipoIcms: ''
  }),
  computed: {
    tipoIcmsId: {
      get() {
        return this.fornecedor.tipoICMS?.id
      },
      set(id) {
        return (this.newTipoIcms = id)
      }
    }
  },

  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    fornecedorParam() {
      return this.fornecedorParam ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },

  methods: {
    initialize() {
      this.fornecedor = new Fornecedor()
      if (this.$refs.formDialog) this.$refs.formDialog.resetValidation()

      this.fornecedor = this.fornecedorParam
      if (this.operacao === 'editar') {
        this.fornecedor.tipoFornecedor = this.itens.tiposFornecedores.find(
          (item) => item.text === this.fornecedorParam.tipoFornecedor
        ).value
      }
    },

    async salvar(item) {
      this.salvando = true
      this.showMessageError = false

      try {
        const data = {
          ...item,
          tipoICMS: {
            id: this.newTipoIcms
          },
          documento: item.documento.replaceAll('.', '').replaceAll('/', '').replaceAll('-', '')
        }

        const fornecedorSalvo =
          this.operacao === 'adicionar'
            ? await FornecedorService.create({ ...data, conferido: false })
            : await FornecedorService.update(data.id, data)

        this.$emit('confirmado', fornecedorSalvo)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
